import { gql, useLazyQuery } from '@apollo/client';
import React from 'react';
import { useLocation } from 'react-router-dom';
import {makeStyles} from "@material-ui/core/styles/index";
import {blue} from "@material-ui/core/colors/index";

import FormCollapse from "./FormCollase";
import Alert from "@material-ui/lab/Alert/Alert";
import Box from "@material-ui/core/Box/Box";

const ADD_REVIEW = gql`
  query($name:String, $email:String, $make: Int, $model: Int, $year: Int, $rating: Int, $description: String, 
  $images: [ImageInput], $lp: String) {
        addReview(reviewInput: {name:$name, email:$email, make: $make, model: $model, year: $year, rating: $rating,
         description: $description, images: $images, lp: $lp}) {
        success
      }
  }
`;

const useStyles = makeStyles((theme) => {
    return {
        avatar: {
            backgroundColor: blue[500],
        },
        h1: {
            fontSize: '1.25rem',
            fontWeight: 'normal',
            margin:0
        },
        latestOffers: {
            margin: '15px 0 10px 0',
        },
        contentHeader: {
            fontSize: '1.25rem',
            fontWeight: 'normal',
            marginTop: 15,
            marginBottom: 10,
            marginLeft: 0,
            whiteSpace: 'pre-line',
        },
        description: {
            whiteSpace: 'pre-line',
        },
        contactIcon: {
            display: 'flex',
            alignItems: 'center',
            marginLeft: 0,
            fontWeight: 'bold'
        },
        reviewItem: {
            margin: '20px 0px 20px 0px',
            border: '1px solid #ccc',
            padding: '10px 10px',
            borderRadius: 5,
        }
    }});

export default function AddReview(props) {

    const location = useLocation();
    const classes = useStyles();


    const [addReview, { loading: requestLoading, error: requestError, data: requestData }] = useLazyQuery(ADD_REVIEW);

    const sendRequest = (data) => {
        addReview(data);
    };

    return (
        <>
            <Box mr={2}>
                {requestData ? <Alert severity="success">
                        Thank you very much for your review! Once we verify little things, it will be available to visitors and we will give you an feedback!
                    </Alert> :
                    <FormCollapse item={props.item} lp={props.lp} sendRequest={sendRequest}
                                  requestError={requestError} open={true} isMobile={props.isMobile} isPopup={props.isPopup}/>}
            </Box>
        </>
    );
}


